import { useMutation, useQueryClient } from '@tanstack/react-query';

import { adminApi } from '../api/admin.adapter';
import type {
  Admin,
  InviteAdminInput,
  RootTransferInput,
  RootTransferResult,
  UpdateAdminInput,
} from '../types/admin.types';
import { adminQueryKeys } from './use-admins';

export function useInviteAdmin() {
  const qc = useQueryClient();
  return useMutation<Admin, Error, InviteAdminInput>({
    mutationFn: (input) => adminApi.inviteAdmin(input),
    onSuccess: () => {
      qc.invalidateQueries({ queryKey: adminQueryKeys.all });
    },
  });
}

export function useResendInvitation() {
  return useMutation<void, Error, number>({
    mutationFn: (id) => adminApi.resendInvitation(id),
  });
}

export function useUpdateAdmin() {
  const qc = useQueryClient();
  return useMutation<Admin, Error, { id: number; input: UpdateAdminInput }>({
    mutationFn: ({ id, input }) => adminApi.updateAdmin(id, input),
    onSuccess: () => {
      qc.invalidateQueries({ queryKey: adminQueryKeys.all });
    },
  });
}

export function useResetPassword() {
  return useMutation<void, Error, number>({
    mutationFn: (id) => adminApi.resetPassword(id),
  });
}

export function useRootTransfer() {
  const qc = useQueryClient();
  return useMutation<RootTransferResult, Error, RootTransferInput>({
    mutationFn: (input) => adminApi.rootTransfer(input),
    onSuccess: () => {
      qc.invalidateQueries({ queryKey: adminQueryKeys.all });
    },
  });
}
